var map = {
	"./iec62325-451-n-eiccode_v1_2.xsd": 92979,
	"./urn-entsoe-eu-local-extension-types.xsd": 16059,
	"./urn-entsoe-eu-wgedi-codelists.xsd": 15885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2686;